export default __webpack_public_path__ + "static/media/ECommerce-Backend.67d84761.png";